import { useEffect, useState } from "react"
import CalculateCard from "@/components/analysis/calculate/CalculateCard"
import ToolTips from "@/constants/ToolTips"
import { useEditAnalysis } from "@/queries/analysis"
import CalculatorItem from "@/components/calculate/CalculatorItem"
import { useStore } from "@nanostores/react"
import { currentStrategy } from "@/stores/strategyStore"
import { type AnalysisType } from "@/generated/graphql"
import * as AnalyzerEvents from "@/analytics/events/analyzer"

interface OperatingAssumptionsSectionProps {
  analysis?: AnalysisType | null
}

const OperatingAssumptionsSection: React.FC<
  OperatingAssumptionsSectionProps
> = ({ analysis }: OperatingAssumptionsSectionProps) => {
  const strategy = useStore(currentStrategy)

  const [rentMonthly, setRentMonthly] = useState<number | null>()
  const [opex, setOpex] = useState<number | null>()
  const editAnalysisMutation = useEditAnalysis()

  useEffect(() => {
    if (analysis) {
      setRentMonthly(analysis.rent)
      setOpex(analysis.opex)
    }
  }, [analysis])

  if (!analysis || strategy === "Fix & Flip") {
    return null
  }

  const handleBlur = (title: string, value: number | null | undefined) => {
    AnalyzerEvents.analysisEditSubmitted({
      analysis,
      editedField: {
        fieldName: title,
        newValue: value,
      },
      fromScreen: "Subject Property Calculate",
      toScreen: "Subject Property Calculate",
    })
    editAnalysisMutation.mutate({
      analysisId: analysis?.id,
      analysisInput: {
        rent: rentMonthly,
        opex,
      },
    })
  }

  return (
    <CalculateCard title="Operating Assumptions">
      <CalculatorItem
        title="Rent (mo)"
        value={rentMonthly}
        tooltip={ToolTips.rent}
        onBlur={() => {
          handleBlur("Operating Assumptions", rentMonthly)
        }}
        onValueChange={setRentMonthly}
      />
      <CalculatorItem
        title="Operating Exp (mo)"
        value={opex}
        tooltip={ToolTips.operatingExpenses}
        onBlur={() => {
          handleBlur("Operating Exp (mo)", opex)
        }}
        onValueChange={setOpex}
      />
    </CalculateCard>
  )
}

export default OperatingAssumptionsSection
